export enum STEPS {
  CART = 'cart',
  SWEDISH_PROFILE = 'swedish-profile',
  BILLING_PROFILE = 'billing-profile',
  DOMAIN_PROFILE = 'domain-profile',
  PAYMENT_METHOD = 'payment-method',
  SERVICE_SETTINGS = 'service-settings',
  RECAPITULATION = 'recapitulation',
  TRANSFER_SUMMARY = 'transfer-summary',
  TYPE_DOMAIN_NAME = 'type-domain-name',
}

export enum HostingTutorialStepTypes {
  Default,
  List,
  NoOptions,
}

export enum CartItemCode {
  DOMAIN_REGISTER = 'domain-register',
  DOMAIN_TRANSFER = 'domain-transfer',
}
